import api from './client';

const BASE = '/api/documents';

/**
 * @param {Object} params - { type, status, storeId, from, to, reference }
 * @param {Object} config - axios config (e.g. auth headers)
 */
export async function fetchDocuments(params = {}, config = {}) {
  const { data } = await api.get(BASE, { params, ...config });
  return Array.isArray(data) ? data : [];
}

export async function deleteDocument(id, config = {}) {
  await api.delete(`${BASE}/${id}`, config);
}

export async function fetchDocumentById(id, config = {}) {
  const { data } = await api.get(`${BASE}/${id}`, config);
  return data;
}

/**
 * @param {Object} payload - { type, storeId?, date?, items, supplierId?, reason?, reference?, status? }
 */
export async function createDocument(payload, config = {}) {
  const { data } = await api.post(BASE, payload, config);
  return data;
}

export async function updateDocument(id, payload, config = {}) {
  const { data } = await api.put(`${BASE}/${id}`, payload, config);
  return data;
}

export async function updateDocumentStatus(id, status, config = {}) {
  const { data } = await api.put(`${BASE}/${id}/status`, { status }, config);
  return data;
}

export const DOCUMENT_TYPES = ['purchase', 'stock_return', 'sales', 'refund', 'proforma', 'inventory_count', 'loss_damage'];
export const DOCUMENT_STATUSES = ['draft', 'submitted', 'completed', 'cancelled'];
